import React from "react";

function VideoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.75"
      height="19.75"
      viewBox="0 0 19.75 19.75"
    >
      <path
        id="Path_22544"
        data-name="Path 22544"
        d="M3,4.09A1.09,1.09,0,0,1,4.09,3H21.66a1.09,1.09,0,0,1,1.09,1.09V21.66a1.09,1.09,0,0,1-1.09,1.09H4.09A1.09,1.09,0,0,1,3,21.66Zm8.363,4.851a.439.439,0,0,0-.682.365v7.138a.439.439,0,0,0,.682.365l5.353-3.569a.439.439,0,0,0,0-.73Z"
        transform="translate(-3 -3)"
        fill="#fff"
      />
    </svg>
  );
}

export default VideoIcon;
